<template>
  <div class="b2b-input-letters">
    <template v-for="letter in $_letters">
      <a
        v-text="letter"
        class="b2b-input-letters__letter"
        :key="letter"
        :class="{
          'b2b-input-letters__letter--active': letter === value,
        }"
        @click.stop="$_onClickLetter(letter)" />
    </template>
  </div>
</template>

<script>
import ModelMixin from '../../../mixins/base/model-mixin';

export default {
  name: 'b2b-input-letter',

  mixins: [
    ModelMixin(String),
  ],

  props: {
    items: Array,
  },

  computed: {
    $_letters() {
      if (this.items) {
        return this.items;
      }

      return ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N',
        'O', 'P', 'Q', 'R', 'S', 'U', 'V', 'W', 'X', 'Y', 'Z', '#'];
    },
  },

  methods: {
    $_onClickLetter(letter) {
      if (this.value === letter) {
        this.$emit('input', null);
      } else {
        this.$emit('input', letter);
      }
    },
  },
};
</script>

<style lang="scss">
$colorPrimary: var(--main-color--primary);
$colorPrimaryText: var(--main-color--primary-text);

.b2b-input-letters {
  max-width: 100%;
  overflow-x: auto;

  display: flex;
  align-items: center;
  justify-content: space-between;

  &__letter {
    min-width: 32px;
    min-height: 32px;

    display: inline-block;

    cursor: pointer;

    text-align: center;
    line-height: 32px;

    border-radius: 16px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }

    &--active {
      color: $colorPrimaryText;
      background-color: $colorPrimary;

      &:hover {
        opacity: 0.5;
        background-color: $colorPrimary;
      }
    }
  }
}
</style>
